<template>
  <div id="app">
    <template v-if="!isMaintenance">
      <router-view />
      <RedirectModal
        ref="redirectModal"
        :path="redirectModalPath"
        :redirectedCountry="redirectedCountry"
        @modal-closed="redirectModalState = false"
      />
    </template>
    <template v-else>
      <Maintenance />
    </template>
  </div>
</template>

<script>
import UserStore from '@/stores/user';
import RedirectModal from './components/modals/RedirectModal';
import Maintenance from './components/maintenance';
import { computed } from 'vue';

export default {
  components: {
    RedirectModal,
    Maintenance,
  },
  provide() {
    return {
      openRedirectModal: this.openRedirectModal,
      redirectModalState: computed(() => this.redirectModalState),
    };
  },
  computed: {
    isMaintenance() {
      return process.env.VUE_APP_MAINTENANCE === 1;
    },
  },
  data() {
    return {
      redirectedCountry: null,
      redirectModalPath: '',
      browserLang: null,
      customLocales: {
        PT: 'pt',
        BR: 'pt',
      },
      mukellefLanguages: ['tr'],
      workhyLanguages: ['en', 'pt'],
      redirectModalState: false,
    };
  },
  created() {
    const currentDomain = document.domain;
    let language = 'tr';

    if (currentDomain.includes('workhy') === true) {
      language = 'en';
      this.$i18n.fallbackLocale = 'en';
      this.$store.commit('setCurrentPriceFormatNationId', 2);
    } else {
      this.$i18n.fallbackLocale = 'tr';
      this.$store.commit('setCurrentPriceFormatNationId', 1);
    }

    this.handleRedirection(this.$route);

    // set the current language for i18n.
    document.querySelector('html').setAttribute('lang', language);
    if (
      (!this.mukellefLanguages.includes(localStorage.getItem('lang')) && this.isWebsiteMukellef) ||
      (!this.workhyLanguages.includes(localStorage.getItem('lang')) && !this.isWebsiteMukellef)
    ) {
      this.$i18n.locale = language;
      localStorage.setItem('lang', language);
    }
    // this.$i18n.locale = language;
    this.checkBrowserLanguage();

    if (!this.isMaintenance) {
      if (!$cookies.isKey('userIpLocale')) {
        this.getNationById();
      } else {
        this.setStoreIp($cookies.get('userIpLocale').toUpperCase());
        this.checkAndSetLocale($cookies.get('userIpLocale').toUpperCase());
      }
    }

    if (this.customLocales[this.browserLang]) {
      this.setLocale(this.browserLang);
    }
  },
  methods: {
    handleRedirection(route) {
      const currentDomain = document.domain;
      const baseUri = currentDomain.includes('workhy')
        ? process.env.VUE_APP_WORKHY_DASHBOARD_URL
        : process.env.VUE_APP_MUKELLEF_DASHBOARD_URL;
      let targetPath = '';

      switch (route.path) {
        case '/login':
          targetPath = 'login';
          break;
        case '/forgot-password':
          targetPath = 'forgot-password';
          break;
        case '/renew-password':
          targetPath = 'renew-password';
          break;
        case '/register':
          targetPath = 'register';
          break;
        case '/transfer':
          targetPath = 'register';
          break;
        case '/product':
          targetPath = 'register';
          break;
        case '/connect':
          targetPath = 'connect';
          break;
        case '/':
          targetPath = 'register';
          break;
        default:
          return;
      }

      const queryString = Object.keys(route.query)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(route.query[key])}`)
        .join('&');

      const targetUrl = `${baseUri}${targetPath}${queryString ? '?' + queryString : ''}`;

      window.location.replace(targetUrl);
    },
    setLocale(data) {
      const lang = data.toLowerCase();
      if (
        (this.mukellefLanguages.includes(lang) && this.isWebsiteMukellef) ||
        (this.workhyLanguages.includes(lang) && !this.isWebsiteMukellef)
      ) {
        this.$i18n.locale = lang;
        localStorage.setItem('lang', data);
      }

      /* let lang = '/' + data;

      if (lang === '/tr') {
        lang = '';
      }
      let queryString = '';
      for (const [k, v] of Object.entries(this.$route.query)) {
        queryString += queryString ? '&' : '?';
        if (k != 'step') queryString += k.toString() + '=' + v.toString();
        else queryString += k.toString() + '=1';
      }
      const path = this.$route.path;
      const isLanguageOther = path.includes('/' + this.$i18n.locale + '/');
      let currentPathWithoutLanguage;
      if (isLanguageOther) {
        currentPathWithoutLanguage = path.split('/' + this.$i18n.locale + '/')[1];
      } else {
        currentPathWithoutLanguage = path.substring(1);
      }
      localStorage.setItem('lang', data); */
    },
    setStoreIp(data) {
      this.$store.commit('setUserIpLocale', data);
    },
    checkAndSetLocale(data) {
      if (this.customLocales[data]) {
        this.setLocale(this.customLocales[data]);
      }
    },
    getNationById() {
      UserStore.dispatch('checkUserNationByUrl').then((s) => {
        const lang = s.data.toUpperCase();

        $cookies.set('userIpLocale', lang, '1d');
        this.setStoreIp(lang);
        this.checkAndSetLocale(lang);
      });
    },
    checkBrowserLanguage() {
      const browserLang = (navigator.language || navigator.userLanguage).toUpperCase();
      if (browserLang) {
        this.browserLang = browserLang.split('-')[0];
      }
    },
    openRedirectModal(country, path = '') {
      console.log('country:', country);
      this.redirectedCountry = country;
      this.redirectModalPath = path;
      this.redirectModalState = true;
      window.document.getElementById('redirectModal').click();
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="less">
.condition-title {
  max-width: 470px;
  height: 160px;
  padding-top: 64px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 24px;
  padding-top: 115px;
  font-weight: bold;
  h3 {
    color: rgb(47, 48, 52);
    font-size: 32px;
    line-height: 2.5rem;
    white-space: none;
    text-align: center;
    margin: 0px 0px 0.5em;
    @media (max-width: 992px) {
      margin-bottom: 24px;
      margin-top: 24px;
      font-size: 33px !important;
      line-height: 40px !important;
    }
  }
  p {
    font-size: 16px;
    line-height: 1.5rem;
    margin: 0.5rem 0px 0px;
    font-weight: 500;
    color: rgb(74, 75, 78);
  }
}

.article-body {
  max-width: 870px;
  line-height: 1.75rem;
  color: rgb(74, 75, 78);
  margin: 0 auto;

  table td {
    padding: 1rem;
    border: 1px solid #868686;
  }

  .privacy-policy {
    td:not(:last-child) {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
  }

  @media (max-width: 992px) {
    margin-top: 24px;
  }
  dl {
    color: rgb(74, 75, 78);
    margin-bottom: 2.5rem;
    margin-top: 2.5rem;
    background: rgb(246, 246, 246);
    border-radius: 15px;
    padding: 40px 102px 40px 48px;
    @media (max-width: 992px) {
      padding: 45px 33px 49px 35px;
      font-size: 1.125rem;
      line-height: 1.75rem;
      color: rgb(74, 75, 78);
    }
  }
  dl dt {
    font-weight: normal;
    font-size: 18px;
    line-height: 1.75rem;
    padding-bottom: 1.5rem;
    padding-left: 34px;
    border-left: 3px solid rgb(15, 161, 162);
  }
  dl dd {
    padding-left: 1.5rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: normal;
    font-style: normal;
    border-left: 3px solid rgb(15, 161, 162);
    margin: 0px;
    font-weight: 700;
  }
  h3 {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-top: 2rem;
    margin-bottom: 0.5rem;
  }
  ol {
    list-style-type: lower-alpha;
    list-style-position: outside;
    padding-left: 40px;
    margin: 1.75rem 0px;
  }
  .non-style-type-field,
  .non-style-type-field ol,
  .non-style-type-field ul {
    list-style-type: none !important;
  }
  li {
    font-size: 1.125rem;
    line-height: 1.75rem;
    padding-left: 0.5rem;
    margin: 0.625rem 0px;
  }
  p {
    margin-bottom: 1.75rem;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-size: 1.125rem;
    line-height: 1.75rem;
    color: rgb(74, 75, 78);
  }
}

.article-body {
  padding-top: 2px;
  h1 {
    font-size: 1.875rem;
    line-height: 2.375rem;
    margin-top: 3rem;
    margin-bottom: 2rem;
    color: rgb(74, 75, 78);
  }
  h2 {
    font-size: 1.875rem;
    line-height: 2.375rem;
    margin-top: 3rem;
    margin-bottom: 2rem;
    color: rgb(74, 75, 78);
  }
  p {
    margin-bottom: 1.75rem;
    color: rgb(74, 75, 78);
  }
  ul {
    list-style-position: outside;
    list-style-type: revert;
    padding-left: 40px;
    margin: 1.75rem 0px;
  }
  li {
    font-size: 1.125rem;
    line-height: 1.75rem;
    padding-left: 0.5rem;
    margin: 0.625rem 0px;
  }
  a {
    color: rgb(9, 139, 140);
  }
}

.arrow {
  top: -5px;
  left: 0px;
  width: 1.25rem;
  display: inline-block;
  position: relative;
  span {
    position: absolute;
    width: 0.75rem;
    height: 0.1rem;
    display: inline-block;
    transition: all 0.2s ease;
    &:first-of-type {
      left: 0;
      transform: rotate(45deg);
    }
    &:last-of-type {
      right: 0;
      transform: rotate(-45deg);
    }
  }
  &.active {
    span {
      &:first-of-type {
        transform: rotate(-45deg);
      }
      &:last-of-type {
        transform: rotate(45deg);
      }
    }
  }
}

.otp-field {
  .otp-input {
    width: 100%;
    aspect-ratio: 1 / 1;
    padding: 5px;
    margin: 0 14px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    background: #f9f9f9;
    @media (max-width: 512px) {
      margin: 0 7px;
    }
  }

  .inner-otp-field {
    flex: 1;
  }

  .otp-input:focus-visible {
    background: white;
    border-color: #36cf94;
    outline: none;
    box-shadow: 0px 0px 0px 3px rgba(0, 170, 107, 0.12);
  }

  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &.invalid-otp-field {
    .otp-input {
      border: 1px solid #f6576e;
      box-shadow: 0px 0px 0px 3px rgba(246, 87, 110, 0.12);
    }
  }
}

.mukellef-button {
  -webkit-transform: translateZ(0);
  display: inline-block;
  font-weight: 500;
  transition: all 150ms ease-in-out;
  letter-spacing: -0.48px;
  font-size: 15px;
  line-height: 18px;
  cursor: pointer;
}
.m-button1 {
  display: inline-block;
  border-radius: 2px;
  font-weight: 500;
  transition: all 150ms ease-in-out;
  letter-spacing: -0.48px;
  font-size: 16px;
  line-height: 18px;
  flex-shrink: 0;
  cursor: pointer;
  border: none;
  &:focus {
    box-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  &:disabled {
    pointer-events: none;
  }
}
.button-size-small {
  padding: 0.75rem 1rem;
}
.button-size-normal {
  padding: 1rem 1.5rem;
}
.button-type-primary {
  background-color: #00aa6b;
  color: #ffffff;
  &:hover {
    background-color: #00854a;
  }
  &:focus {
    box-shadow: 0px 0px 0px 3px rgba(0, 133, 74, 0.24);
  }
  &:disabled {
    background-color: #00aa6b;
    opacity: 0.6;
  }
}
.button-type-secondary {
  background-color: #191335;
  color: #ffffff;
  &:hover {
    background-color: #3c3359;
  }
  &:focus {
    box-shadow: 0px 0px 0px 3px rgba(99, 88, 129, 0.24);
  }
  &:disabled {
    opacity: 0.4;
  }
}
.button-type-dark {
  background-color: #000000;
  color: #ffffff;
  &:hover {
    background-color: #1f1f1f;
  }
  &:focus {
    box-shadow: 0px 0px 0px 3px rgba(57, 57, 57, 0.24);
  }
}
.button-type-outline-light {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #000000;
  &:hover {
    background-color: #f3f3f3;
  }
  &:focus {
    box-shadow: 0px 0px 0px 3px rgba(176, 176, 176, 0.24);
  }
}
.button-type-outline-dark {
  border: 1px solid #ffffff;
  background-color: transparent;
  color: #ffffff;
  &:hover {
    border-color: #dddddd;
  }
  &:focus {
    box-shadow: 0px 0px 0px 3px rgba(176, 176, 176, 0.24);
  }
}
.selectable-field {
  cursor: pointer;
  user-select: none;
}

.check-field {
  min-width: 23px;
  height: 23px;
  border: 2.4px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease-in-out;
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &::before {
    content: '';
    opacity: 0;
  }
}

.selectable-field.selected {
  .check-field {
    background-color: #00aa6b; /* Purple-500 */
    border-color: #00aa6b;

    &::before {
      content: url('/img/checkv2.svg');
      display: block;
      height: 20px;
      width: 20px;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 1;
      text-align: center;
      line-height: 19px;
      z-index: 2;
    }
  }
}

.product-header-field {
  font-size: 18px;
  line-height: 27px;
  font-weight: 500;
  color: black;
}

.new-product-top-field {
  gap: 8px;
  display: flex;
  align-items: center;
  flex-direction: row;
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }

  .new-product-top-field-inside {
    gap: 8px;
    display: flex;
    align-items: center;
    order: 1;

    @media (max-width: 576px) {
      order: 2;
    }
  }

  .check-field {
    align-self: start;
    margin-top: 3px;
  }

  .new-badge-field {
    background: #00aa6b;
    padding: 4px;
    border-radius: 60px;
    font-weight: 500;
    line-height: 21px;
    color: white;
    order: 2;
    @media (max-width: 576px) {
      order: 1;
    }
  }
  .new-product-name {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
  }
}
.new-product-description {
  font-size: 14px;
  line-height: 21px;
  display: block;
  margin-top: 8px;
  color: black;
}
.new-product-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  .new-product-feature-item {
    background: #f1faf4;
    padding: 4px 12px 4px 8px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    line-height: 21px;
    color: black;
  }
}
.secondary-price-field {
  font-size: 18px;
  line-height: 32px;
  color: black;
  font-weight: 500;
}
.old-price-field {
  color: #727272;
  font-weight: 500;
  display: flex;
  align-items: center;

  .old-price {
    font-size: 16px;
  }
  .fee-text {
    font-size: 14px;
  }
}
.new-product-bottom-field {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  @media (max-width: 576px) {
    flex-direction: column;
  }

  .new-price-field {
    font-weight: 500;
    display: flex;
    align-items: center;
    margin-top: 4px;
    gap: 4px;

    .new-price {
      color: black;
      font-size: 24px;
      line-height: 36px;
    }
    .fee-text {
      color: #727272;
      font-size: 16px;
      line-height: 24px;
    }
  }

  .bottom-left-field {
    flex: 1 1 0%;
  }
  .bottom-right-field {
    align-self: flex-end;
    margin-top: 8px;
    @media (max-width: 576px) {
      align-self: stretch;
    }

    .price-badge-field {
      color: white;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      background: #00aa6b;
      padding: 8px;
      border: 1px solid #ddd;
      justify-content: center;
    }
  }
}
.alert-text-new {
  font-size: 14px;
  line-height: 21px;
  color: black;
}

.alert-inner-field {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  .chevron-item {
    color: black;
  }
}

.additional-product {
  background: #f9f9f9;
  border: 1.2px solid #ddd;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  margin-top: 12px;
  .additional-product-right-field {
    gap: 12px;
  }
}

.additional-product-selectable {
  background: white;
  border: 1.2px solid #ddd;
  align-items: center;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin-top: 12px;
  .additional-product-right-field {
    gap: 4px;
  }
}

.additional-product-left-field {
  display: flex;
  gap: 8px;
}

.product-name-field {
  font-size: 14px;
  font-weight: 500;
  color: black;
  line-height: 21px;
}

.additional-product-right-field {
  display: flex;
  align-items: center;

  .price-text-field {
    font-size: 16px;
    color: black;
    font-weight: 500;
  }

  .price-period-field {
    font-size: 13px;
    color: #727272;
    line-height: 32px;
    font-weight: 500;
  }
  .colorful-text-field {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    background: linear-gradient(274.25deg, #9c74ff 50%, #00aa6b 100%);
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% 100%, 100% 100%;
    background-position: var(--gradient-position) 50%, 50% 50%;
  }
}

.box-content-field {
  padding: 24px 0px;
  color: #4b5563;
  flex-wrap: wrap;

  .main-features {
    font-size: 15px;
  }

  .features-spacing {
    margin-top: 1rem;
  }

  .features-full,
  .features-half,
  .features-additional-half {
    li {
      margin-bottom: 6px;
    }
  }

  .features-half,
  .features-additional-half {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;

    li {
      flex-basis: calc(50% - 10px);
      max-width: calc(50% - 10px);
      padding: 0.5rem;
      background: #f1fafe;
      border-radius: 0.25rem;

      .feature-item {
        flex-flow: wrap;

        .feature-text {
          width: calc(100% - 32px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      @media (max-width: 576px) {
        flex-basis: 100%;
        max-width: 100%;
      }
    }
  }
}
.modal-footer.wrap-footer {
  flex-wrap: wrap;
  gap: 8px;
}
</style>
